import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Role } from '../models/role';

@Injectable({
    providedIn: 'root'
})

export class RoleDataService {

    controller = 'RoleData';
    constructor(private base: BaseService) { }

    getAccessiblePagesByUser(userId: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetAccessiblePagesByUsers`, { userId });
    }

    getRoles(): Observable<ApiObjectData> {
        return this.base.gets<ApiObjectData>(`services/app/${this.controller}/GetAllRoles`);
    }

    createRole(obj: Role): Observable<ApiObjectData> {
        return this.base.save<ApiObjectData>(`services/app/${this.controller}/CreateRole`, obj)
    }

    getRoleById(roleId: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetRoleById`, { roleId });
    }

    delete(RoleID: number) {
        return this.base.deleteByRoleId<ApiObjectData>(`services/app/${this.controller}/Delete`, RoleID);
    }
}